import React, { Component } from 'react';
import ProductTileConnector from '../containers/product-tile-connector';
import InfiniteScroller from './shared/infinite-scroller';
import NonSearchResult from './product/image-coomingsoon';
import APP_DEFAULTS from '../constants/app-defaults';

class ProductList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState((prevState) => ({ currentPage: prevState.currentPage + 1 }));
    }

    loadMoreProducts() {
        return this.props.loadMoreProducts(this.state.currentPage + 1, this.props.locale.currentLocale);
    }

    render() {
        let infiniteScroller = null;
        const productList = this.props.products.map((product, idx) => <ProductTileConnector key={idx} product={product} />);

        if (this.props.products.length > 0) {
            infiniteScroller = (
                <InfiniteScroller loadMore={this.loadMoreProducts.bind(this)} pageCount={this.props.pageCount} currentPage={this.state.currentPage}>
                    {productList}
                </InfiniteScroller>
            );
        } else {
            infiniteScroller = (
                <NonSearchResult />
            );
        }

        return (
            <article className="product-list-container product-section">
                <div className="product-list">
                    <div id="product-infinite-scroll">{infiniteScroller}</div>
                </div>
            </article>
        );
    }
}

export default ProductList;



/** WEBPACK FOOTER **
 ** ./src/components/product-list.jsx
 **/